import { render } from "./ViewTransfert.vue?vue&type=template&id=3c765b98&ts=true"
import script from "./ViewTransfert.vue?vue&type=script&lang=ts"
export * from "./ViewTransfert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__